import { configureStore } from '@reduxjs/toolkit';
import modalReducer from 'reducer/modalReducer';


export default configureStore({
  reducer: {
    modal: modalReducer,
  }
});
